(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-s-k-press"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var splide = new Splide('#main-slider', {
    type      : 'fade',
    rewind    : true,
    pagination: false,
    arrows    : true,
    autoHeight: true,
    arrowPath : 'M16.1,32.2l12-12l-12-12C16.1,8.3,16.1,32.2,16.1,32.2z',
  });

  var thumbnails = new Splide('#thumbnail-slider', {
    gap: 100,
    type   : 'loop',
    perPage: 5,
    arrows    : false,
    rewind      : true,
    pagination  : false,
    isNavigation: true,
    focus       : 2,
    breakpoints : {
      600: {
        fixedWidth : 60,
        fixedHeight: 44,
      },
      768: {
        destroy: true,
      },
    },
  });

  splide.sync(thumbnails);
  splide.mount();
  thumbnails.mount();
    
    // Step 3: Define the height update function
    function updateHeight() {
      const activeSlide = splide.Components.Slides.getAt(splide.index);
      if (activeSlide) {
        // Get all content elements in the slide (images, videos)
        const contentElements = activeSlide.slide.querySelectorAll('div');
        let maxHeight = 0;
        
        // Find the tallest element
        contentElements.forEach(element => {
          maxHeight = Math.max(maxHeight, element.offsetHeight);
        });
        
        // Set the height (add padding if needed)
        splide.root.style.height = `${maxHeight}px`;
      }
    }
    
    // Step 4: Add event listeners for height updates
    
    // Handle first slide when slider is mounted
    splide.on('mounted', function() {
      // Get all images in the slider
      const images = splide.root.querySelectorAll('li');
      let imagesLoaded = 0;
      
      // If there are no images, update height immediately
      if (images.length === 0) {
        updateHeight();
        return;
      }
      
      // Check if all images are already loaded
      images.forEach(img => {
        if (img.complete) {
          imagesLoaded++;
          if (imagesLoaded === images.length) {
            updateHeight();
          }
        } else {
          // Wait for image to load
          img.addEventListener('load', function() {
            imagesLoaded++;
            if (imagesLoaded === images.length) {
              updateHeight();
            }
          });
        }
      });
      
      // Fallback: update height after a short delay anyway
      setTimeout(updateHeight, 100);
    });
    
    // Update height when slides change
    splide.on('moved', updateHeight);
    splide.on('active', updateHeight);
    
    // Update height when window is resized
    window.addEventListener('resize', updateHeight);
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template-product"]) return;
  try {
      
// COMPLEMENTARY PRODUCTS
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.complementary-products--wrapper');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.complementary-products--wrapper');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
